export function Card({ title, desc, buttonText, buttonLink, img, border, bgColor, text }) {
  const aProps = buttonLink ? { href: buttonLink } : null;
  return (
    <div className="mx-5 mt-14 mb-32 flex flex-col items-start justify-between lg:mx-auto lg:flex-row lg:items-center">
      <div className="flex w-full flex-col justify-evenly text-left lg:w-[40%] lg:items-start">
        {title && <h1 className="heading-1">{title}</h1>}
        {desc && <p className="text-para mb-5 mt-3 text-xl font-black lg:text-[22px]">{desc}</p>}

        <a
          {...aProps}
          className={`text-md mt-2 w-fit rounded-lg px-4 py-2 font-satoshi-medium font-semibold uppercase md:text-lg lg:py-4 lg:px-12 ${bgColor} ${text} cursor-pointer border border-red`}
        >
          <div>{buttonText}</div>
        </a>
      </div>
      <div className={`mt-10 w-full lg:mt-0 lg:w-6/12`}>
        <img src={img} alt="" />
      </div>
    </div>
  );
}

export function ContentCard({
  bgColor,
  content,
  align = 'items-start',
  text = 'text-left',
  width,
  height,
}) {
  return (
    <div className={`${bgColor} m-auto h-full rounded-md p-4 lg:m-3`}>
      <ul className={`mb-2 flex flex-col items-center md:${align}`}>
        <li>
          <img src={content.icon} alt="" className={`${height} ${width} mb-2`} />
        </li>
        <li
          className={`card-heading my-1 font-satoshi-bold text-lg font-bold  lg:my-3 lg:text-[22px] ${text}`}
        >
          <span>{content.title}</span>
        </li>
        <li className={`card-para font-satoshi-medium text-base font-medium  ${text}`}>
          {content.value}
        </li>
      </ul>
    </div>
  );
}

export function PanelistCard({ image, name, designation, company, linkedinUrl }) {
  return (
    <a
      className={`flex w-full  cursor-pointer flex-col items-center rounded-xl bg-blue-4 py-1 px-2 shadow-md hover:shadow-lg`}
      href={linkedinUrl ? linkedinUrl : '#'}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ul className="mb-2 mt-2 flex flex-col items-center justify-center pt-0 text-sm ">
        <li>
          <img src={image} alt={name} className="mx-auto mt-2 h-32 w-32 rounded-full" />
        </li>
        <li>
          <div className="mt-4 flex flex-col items-center child:mb-1">
            <div className="p-0.05 text-center text-base font-extrabold capitalize">
              <span>{name}</span>
            </div>
            <div className="blue-2 lg:p-0.05 mt-1 break-words px-2 text-center text-sm capitalize text-red">
              <span>{designation}</span>
            </div>
            {company && (
              <div className="p-0.05 mt-2 font-satoshi-bold text-sm font-bold  capitalize text-gray-5">
                <img src={company} alt="" style={{ height: '36px', width: '100%' }} />
              </div>
            )}
          </div>
        </li>
      </ul>
    </a>
  );
}
